import React from 'react';
import Card from '../Card';
import './ChannelComparison.css';

export default function ChannelComparison({ channels, loading }) {
  if (loading) {
    return (
      <Card>
        <h2 className="card-title">Channel Performance</h2>
        <div style={{ padding: 'var(--spacing-lg)', textAlign: 'center', color: 'var(--text-secondary)' }}>
          Loading channel data...
        </div>
      </Card>
    );
  }

  if (!channels || channels.length === 0) {
    return (
      <Card>
        <h2 className="card-title">Channel Performance</h2>
        <div style={{ padding: 'var(--spacing-lg)', textAlign: 'center', color: 'var(--text-secondary)' }}>
          No channel data available yet.
        </div>
      </Card>
    );
  }

  // Find max reply rate for scaling bars
  const maxReplyRate = Math.max(...channels.map(ch => ch.reply_rate), 10);

  return (
    <Card>
      <h2 className="card-title">Channel Performance</h2>
      <div className="channel-comparison">
        {channels.map((channel, index) => (
          <div key={`${channel.channel}-${index}`} className="channel-item">
            <div className="channel-header">
              <div className="channel-name">{channel.channel}</div>
              <div className="channel-reply-rate" style={{
                color: channel.reply_rate >= 5 ? 'var(--success)' : channel.reply_rate >= 2 ? 'var(--warning)' : 'var(--text-secondary)'
              }}>
                {channel.reply_rate}%
              </div>
            </div>
            
            <div className="channel-progress">
              <div 
                className="channel-progress-fill"
                style={{ 
                  width: `${(channel.reply_rate / maxReplyRate) * 100}%`,
                  background: channel.reply_rate >= 5 ? 'var(--success)' : channel.reply_rate >= 2 ? 'var(--warning)' : 'var(--text-secondary)'
                }}
              />
            </div>

            <div className="channel-stats">
              <div className="channel-stat">
                <span className="stat-label">Sent:</span>
                <span className="stat-value">{channel.messages_sent}</span>
              </div>
              <div className="channel-stat">
                <span className="stat-label">Replies:</span>
                <span className="stat-value">{channel.replies}</span>
              </div>
              <div className="channel-stat">
                <span className="stat-label">Seen:</span>
                <span className="stat-value">{channel.seen_rate}%</span>
              </div>
              <div className="channel-stat">
                <span className="stat-label">Engaged:</span>
                <span className="stat-value">{channel.engagement_rate}%</span>
              </div>
              <div className="channel-stat">
                <span className="stat-label">Failed:</span>
                <span className="stat-value" style={{ 
                  color: channel.failure_rate > 10 ? 'var(--error)' : 'var(--text-secondary)' 
                }}>
                  {channel.failure_rate}%
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
}
